<template>
  <div>
    <v-card width="100%" class="px-4 py-4" v-if="!$auth.loading && $auth.isAuthenticated" flat>
      <v-progress-linear v-if="loading == true" indeterminate size="36" color="primary"></v-progress-linear>
      <v-combobox v-else class="py-2 caption" v-model="selectedSupplier" cache-items :items="suppliers" item-text="name"
        :search-input.sync="search" item-value="id" label="Set your home organisation" x-small clearable outlined dense
        append-outer-icon="mdi-content-save" :dark="dark" :error-messages="orgError"
        :hint="orgCleared ? 'No home organisation set' : ''" :persistent-hint="orgCleared"
        @click:append-outer="saveHomeOrg()" @click:clear="clearHomeOrg()">
      </v-combobox>

      <div class="login-actions-row">
        <div class="login-actions-left">
          <div>
            <v-btn @click="logout()" v-bind="attrs" v-on="on" text small class="px-0 text-capitalize body-2"
              color="secondary">Logout <v-icon medium right>mdi-logout</v-icon></v-btn>
          </div>
          <div>
            <v-btn @click="shareLink = true, generateLink()" v-bind="attrs" v-on="on"
              :disabled="isClusterRoute || isReportRoute" text small class="px-0 text-capitalize body-2"
              color="secondary">Share
              Page<v-icon medium right outline>mdi-share</v-icon></v-btn>
          </div>
        </div>
        <div class="login-actions-right">
          <div class="login-email-switch">
            <v-switch v-model="send_emails" label="Receive market intelligence email updates" color="primary"
              hide-details dense class="mt-0" @change="saveEmailPreferences"></v-switch>
            <!-- <p class="caption text--secondary mt-2 mb-0">
              Daily digest and alerts from Tendertrace
            </p> -->
          </div>
        </div>
      </div>
    </v-card>

    <v-dialog v-model="shareLink" max-width="500">
      <v-snackbar v-model="copied" top color="green" dense small max-height="10" max-width="50" timeout="1000">
        Copied to clipboard!
        <!-- <v-btn dark text @click="copied = false">
                Close
              </v-btn> -->
      </v-snackbar>
      <v-card mx-auto flat min-height="180">
        <v-card-title><span>Share Page</span>
          <div class="flex-grow-1"></div> <v-btn icon @click="shareableLink = '', shareLink = false"><v-icon
              style="font-weight:thin;" medium>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-subtitle class="pt-2">Copy and share the shortened URL below with other users</v-card-subtitle>
        <span v-if="shareableLink != ''">
          <v-card flat class="mx-4 py-1" outlined>
            <span class="subtitle-2 ml-4">
              <a :href="shareableLink" style="color:white">{{ shareableLink }}</a></span>
            <span>
              <v-btn class="ml-1" icon @click="copy(shareableLink), shareLink = false"><v-icon color="primary"
                  medium>mdi-content-copy</v-icon></v-btn>
            </span>
          </v-card>
        </span>
        <span v-else>
          <div class="text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </span>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import { bus } from "../main.js";
import axios from "axios";
import {
  getCurrentUserProfile,
  setUserOrg,
  clearUserOrg,
  searchSuppliers,
  updateEmailPreferences
} from "./APIManager.js";
//import { logout, loggedIn } from "./LoginManager";

export default {
  components: {},
  props: { menu: Boolean, authenticated: Boolean },
  data() {
    return {
      selectedSupplier: { name: null, id: null },
      orgError: "",
      orgCleared: false,
      suppliers: [],
      searchTimeout: null,
      shareLink: false,
      shareableLink: "",
      copied: false,
      pwd_dialog: false,
      search_request: false,
      source: "",
      search: "",
      search_terms: {},
      //drawer: true,
      //watched: false,
      view_index: null,
      //creds: {email: "", password:""},
      //username,
      email: "",
      password: "",
      error: false,
      //pw:""
      current_user: null,
      selected: "snapshot",
      current_view: "snapshot",
      token: "",
      isLoggedIn: false,
      currentURL: "",
      supportBody: "",
      loading: false,
      send_emails: true
      //results_drawer: null
    };
  },

  watch: {
    search(val) {
      if (val && val !== this.select) {
        this.lookup(val);
      }
    },
    selectedSupplier() {
      this.orgError = "";
    },
  },

  computed: {

  },

  mounted() {

    this.$nextTick(() => {
      this.loadUser();
    });

  },

  async created() {

  },

  computed: {
    isClusterRoute() {
      // Check if the current route is 'cluster'
      return this.$route.path.includes('cluster');
    },
    isReportRoute() {
      // Check if the current route is 'report'
      return this.$route.path.includes('report');
    }
  },

  methods: {

    close() {
      this.$emit("close", true);
    },

    lookup(searchText) {
      searchSuppliers(searchText).then(results => {
        this.suppliers = results.data || [];

        //this.loading = false;
        ////////////console.log("loadPublishers data: ", results);
      });
    },

    async saveHomeOrg() {
      const selected = this.selectedSupplier;
      const id = selected && typeof selected === 'object' ? parseInt(selected.id, 10) : NaN;

      if (Number.isNaN(id)) {
        // An empty field means "no home org"; free text that wasn't picked
        // from the list has no supplier ID to save.
        const text = typeof selected === 'string' ? selected.trim() : '';
        if (text) {
          this.orgError = "Pick an organisation from the list";
        } else {
          await this.clearHomeOrg();
        }
        return;
      }

      this.loading = true;
      try {
        const results = await setUserOrg(id);
        this.current_user = results.data;
        this.orgCleared = false;

        if (this.current_user.org_id && this.current_user.org_data) {
          this.selectedSupplier = {
            name: this.current_user.org_data.name,
            id: this.current_user.org_data.id
          };
          this.suppliers[0] = this.selectedSupplier;
        }
      } catch (err) {
        this.orgError = (err.response && err.response.data && err.response.data.message)
          || "Couldn't save your home organisation";
      } finally {
        this.loading = false;
      }
    },

    async clearHomeOrg() {
      this.loading = true;
      try {
        await clearUserOrg();
        this.loadUser();
      } catch (err) {
        this.orgError = (err.response && err.response.data && err.response.data.message)
          || "Couldn't clear your home organisation";
        this.loading = false;
      }
    },

    loadUser() {
      this.loading = true;

      getCurrentUserProfile()
        .then(results => {
          // Set current_user if the promise resolves successfully
          this.current_user = results.data;
          this.orgCleared = !!this.current_user.org_cleared;

          if (this.current_user.org_id && this.current_user.org_data) {
            this.selectedSupplier = {
              name: this.current_user.org_data.name,
              id: this.current_user.org_data.id
            };
            this.suppliers[0] = this.selectedSupplier;
          } else {
            this.selectedSupplier = { name: null, id: null };
          }
          if (this.current_user.send_emails !== undefined) {
            this.send_emails = this.current_user.send_emails;
          }
          this.loading = false;
        })
        .catch(() => {
          this.send_emails = true;
          this.loading = false;
        });
    },

    async saveEmailPreferences() {
      try {
        await updateEmailPreferences(this.send_emails);
      } catch (err) {
        console.error('Error saving email preferences:', err);
        this.send_emails = !this.send_emails;
      }
    },

    async copy(txt) {
      try {
        await navigator.clipboard.writeText(txt);
        this.copied = true;
      } catch (e) {

      }
    },
    contactUs() {
      window.open('https://tendertrace.com/contact-us/');
    },
    goToRegistration() {
      this.$router.push(this.$route.query.push || "/register");
    },

    async generateLink() {
      this.currentURL = window.location.href;

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: 'pk_vU6EIAOfRouzmn3x'
        },
        body: JSON.stringify({
          allowDuplicates: false,
          domain: 'go.tendertrace.com',
          originalURL: this.currentURL
        })
      };

      fetch('https://api.short.io/links/public', options)
        .then(response => response.json())
        .then(response => {
          this.shareableLink = response.shortURL
        })
        .catch(err);

      //this.supportBody = await this.shortURL(this.currentURL) + '%0D' + '%0DPlease enter your message below this line.%0D';
    },

    async sendSupportMsg() {
      this.currentURL = window.location.href;

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: 'pk_vU6EIAOfRouzmn3x'
        },
        body: JSON.stringify({
          allowDuplicates: false,
          domain: 'go.tendertrace.com',
          originalURL: this.currentURL
        })
      };

      fetch('https://api.short.io/links/public', options)
        .then(response => response.json())
        .then(response => {
          window.location.href = 'mailto:' + 'support@tendertrace.com?subject=Tendertrace Support Query&body=Source page: ' + response.shortURL + '%0D' + '%0DPlease enter your message below this line.%0D';
          return response.shortURL
        })
        .catch(err);

      //this.supportBody = await this.shortURL(this.currentURL) + '%0D' + '%0DPlease enter your message below this line.%0D';
    },


    // Log the user in
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },


  }
};
</script>

<style scoped>
.login-actions-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-top: 0px;
}

.login-actions-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.login-actions-right {
  min-width: 0;
}

.login-email-switch {
  min-width: 0;
  max-width: 250px;
}
</style>
